import admUser from "./admUser";
import admStudent from "./admStudent";
import admStaff from "./admStaff";
import admGroup from "./admGroup";
import admBilling from "./admBilling";
import admBillingGrid from "./admBillingGrid";
import admOrder from "./admOrder";
import admOrderGrid from "./admOrderGrid";
import admOrderDetail from "./admOrderDetail";
import admBillingReport from "./admBillingReport";
import admDirectory from "./admDirectory";
import admPeriod from "./admPeriod"
import admSubject from "./admSubject";
import admGrades from "./admGrades";
import admGradesRep from "./admGradesRep";
import admEvalConcept from "./admEvalConcept";
import admActivityParts from "./admActivityParts";
import admActivityMasters from "./admActivityMasters";
import admTracking from "./admTracking";
import admBookingList from "./admBookingList";
import admLocalization from "./admLocalization";
import admSuperSection from "./admSuperSection";
import admSectionMembers from "./admSectionMembers";
import admCommitment from "./admCommitment";
import admBehavior from "./admBehavior";
import admJournal from "./admJournal";
import admOtlt from "./admOtlt";
import admAttendanceType from "./admAttendanceType";
import admGradesBehavior from "./admGradesBehavior";
import admActivitySession from "./admActivitySession";
import admGradesMaster from "./admGradesMaster";
import admSection from "./admSection";
import admDates from "./admDates";
import admInfirmary from "./admInfirmary";
import admInfirmaryValues from "./admInfirmaryValues";
import admPublication from "./admPublication";
import admInfo from "./admInfo";
import admPublicationPart from "./admPublicationPart";
import admFlow from "./admFlow";
import admFlowFetch from "./admFlowFetch";
import admAssignmentQst from "./admAssignmentQst";
import admCalendar from "./admCalendar";
import admNotification from "./admNotification";
import admRelatives from "./admRelatives";
import admAudit from "./admAudit";
import admTransport from "./admTransport";
import admFlowInput from "./admFlowInput";
import admFlowResponses from "./admFlowResponses";
import admMedical from "./admMedical";
import admBalance from "./admBalance";
import admUserGroup from "./admUserGroup";

export default [
  {id: 'admUser', path: '/app/admUser', module: admUser},
  {id: 'admStudent', path: '/app/admStudent', module: admStudent},
  {id: 'admStaff', path: '/app/admStaff', module: admStaff},
  {id: 'admGroup', path: '/app/admGroup', module: admGroup},
  {id: 'admBilling', path: '/app/admBilling', module: admBilling},
  {id: 'admBillingGrid', path: '/app/admBillingGrid', module: admBillingGrid},
  {id: 'admOrder', path: '/app/admOrder', module: admOrder},
  {id: 'admOrderGrid', path: '/app/admOrderGrid', module: admOrderGrid},
  {id: 'admOrderDetail', path: '/app/admOrderDetail', module: admOrderDetail},
  {id: 'admBillingReport', path: '/app/admBillingReport', module: admBillingReport},
  {id: 'admDirectory', path: '/app/admDirectory', module: admDirectory},
  {id: 'admPeriod', path: '/app/admPeriod', module: admPeriod},
  {id: 'admSubject', path: '/app/admSubject', module: admSubject},
  {id: 'admGrades', path: '/app/admGrades', module: admGrades},
  {id: 'admGradesRep', path: '/app/admGradesRep', module: admGradesRep},
  {id: 'admEvalConcept', path: '/app/admEvalConcept', module: admEvalConcept},
  {id: 'admActivityParts', path: '/app/admActivityParts', module: admActivityParts},
  {id: 'admActivityMasters', path: '/app/admActivityMasters', module: admActivityMasters},
  {id: 'admTracking', path: '/app/admTracking', module: admTracking},
  {id: 'admBookingList', path: '/app/admBookingList', module: admBookingList},
  {id: 'admLocalization', path: '/app/admLocalization', module: admLocalization},
  {id: 'admSuperSection', path: '/app/admSuperSection', module: admSuperSection},
  {id: 'admSectionMembers', path: '/app/admSectionMembers', module: admSectionMembers},
  {id: 'admCommitment', path: '/app/admCommitment', module: admCommitment},
  {id: 'admBehavior', path: '/app/admBehavior', module: admBehavior},
  {id: 'admJournal', path: '/app/admJournal', module: admJournal},
  {id: 'admOtlt', path: '/app/admOtlt', module: admOtlt},
  {id: 'admActivitySession', path: '/app/admActivitySession', module: admActivitySession},
  {id: 'admAttendanceType', path: '/app/admAttendanceType', module: admAttendanceType},
  {id: 'admGradesBehavior', path: '/app/admGradesBehavior', module: admGradesBehavior},
  {id: 'admGradesMaster', path: '/app/admGradesMaster', module: admGradesMaster},
  {id: 'admSection', path: '/app/admSection', module: admSection},
  {id: 'admDates', path: '/app/admDates', module: admDates},
  {id: 'admInfirmary', path: '/app/admInfirmary', module: admInfirmary},
  {id: 'admInfirmaryValues', path: '/app/admInfirmaryValues', module: admInfirmaryValues},
  {id: 'admPublication', path: '/app/admPublication', module: admPublication},
  {id: 'admInfo', path: '/app/admInfo', module: admInfo},
  {id: 'admPublicationPart', path: '/app/admPublicationPart', module: admPublicationPart},
  {id: 'admFlow', path: '/app/admFlow', module: admFlow},
  {id: 'admFlowFetch', path: '/app/admFlowFetch', module: admFlowFetch},
  {id: 'admAssignmentQst', path: '/app/admAssignmentQst', module: admAssignmentQst},
  {id: 'admCalendar', path: '/app/admCalendar', module: admCalendar},
  {id: 'admNotification', path: '/app/admNotification', module: admNotification},
  {id: 'admRelatives', path: '/app/admRelatives', module: admRelatives},
  {id: 'admAudit', path: '/app/admAudit', module: admAudit},
  {id: 'admTransport', path: '/app/admTransport', module: admTransport},
  {id: 'admFlowInput', path: '/app/admFlowInput', module: admFlowInput},
  {id: 'admAttendanceControl', path: '/app/admAttendanceControl'},
  {id: 'admJustification', path: '/app/admJustification'},
  {id: 'admCommunications', path: '/app/admCommunications'},
  {id: 'admConversations', path: '/app/admConversations'},
  {id: 'admStats', path: '/app/admStats'},
  {id: 'admUsage', path: '/app/admUsage'},
  {id: 'admBalance', path: '/app/admBalance', module: admBalance},
  {id: 'admFlowResponses', path: '/app/admFlowResponses', module: admFlowResponses},
  {id: 'admMedical', path: '/app/admMedical', module: admMedical},
  {id: 'admUserGroup', path: '/app/admUserGroup', module: admUserGroup},
]